import flatten from 'lodash/flatten';
import { cleanConceptPrefix } from '../../utils/stringFormatting.esm.js';

/**
 *
 * @param options list of all reflex options where add-ons are ones with defined parentTestName property
 * @returns a list of TestAutocompleteOption objects where add-ons of same parent test are gouped together,
 * so react-select may render them in separate sections so they're distinguished from regular reflex options.
 */
var getReflexOptionsWithGroupedAddOns = function (options) {
    var currentTestSelectionAddOns = [];
    var otherTests = [];
    options.forEach(function (option) { return (option.parentTestName ? currentTestSelectionAddOns : otherTests).push(option); });
    var addOnGroupLabels = new Set(currentTestSelectionAddOns.map(function (_a) {
        var parentTestName = _a.parentTestName;
        return parentTestName || '';
    }));
    var groupedOptions = Array.from(addOnGroupLabels).map(function (label) { return ({
        label: "".concat(label, " add-ons"),
        options: currentTestSelectionAddOns
            .filter(function (_a) {
            var parentTestName = _a.parentTestName;
            return parentTestName === label;
        })
            .map(function (_a) {
            var label = _a.label, value = _a.value;
            return ({
                label: label,
                value: value,
            });
        }),
    }); });
    return groupedOptions.concat(otherTests);
};
var flattenTestSelectionsToGeneConceptCodes = function (testSelections) {
    return flatten(testSelections.map(function (test) { return test.genes.map(function (_a) {
        var code = _a.code;
        return code;
    }); }));
};
var flattenTestSelectionsToTestCodes = function (testSelections) {
    return flatten(testSelections.map(function (test) { return (test.code ? test.code : test.genes.map(function (gene) { return gene.code; })); }));
};
var removeConceptsFromTestSelections = function (testSelections) {
    var conceptsToRemove = Array();
    testSelections.forEach(function (_a) {
        var genes = _a.genes, code = _a.code;
        if (code) {
            conceptsToRemove.push(code);
        }
        else {
            conceptsToRemove = conceptsToRemove.concat(genes.map(function (gene) { return gene.code; }));
        }
    });
    return conceptsToRemove;
};
var cleanUpCodeForLinkUrl = function (code) { return cleanConceptPrefix(code).replace(/\..+/, ''); };
var isRnaAnalysisTestSelection = function (testName) { var _a; return !!((_a = testName.match(/^Genes Eligible for RNA Analysis$|^Genes Eligible for RNA Analysis \(\d+ genes?\)$/)) === null || _a === void 0 ? void 0 : _a.length); };

export { cleanUpCodeForLinkUrl, flattenTestSelectionsToGeneConceptCodes, flattenTestSelectionsToTestCodes, getReflexOptionsWithGroupedAddOns, isRnaAnalysisTestSelection, removeConceptsFromTestSelections };
//# sourceMappingURL=OrderCard.utils.esm.js.map
